export const styleStudioContent = { padding: "1em" };
